module.exports = __webpack_public_path__ + "static/media/healthy.af3d8d63.svg";